import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";

const base_api = 'https://phillyfoodworks-back-dev.navego.tech'

export const environment = {
  production: false,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    navego: {
      url: 'https://apis.navego.tech/api',
      key: 'dsfgrdf125fdffasd677rrfgr',
      clientNr: '5'
    },
    firebase: {
      apiKey: "AIzaSyBxeM5P6toNU5apVfLTrUdpgx8532yprsQ",
      authDomain: "dev-pf-6cd78.firebaseapp.com",
      projectId: "dev-pf-6cd78",
      storageBucket: "dev-pf-6cd78.appspot.com",
      messagingSenderId: "30992702575",
      appId: "1:30992702575:web:d43e783a9b11779a6bc19a",
      measurementId: "G-7MT23SB5TD"
    },
    fireauth: {
      email: 'javier.franco@eliostudios.co',
      password: '@N4v3g0.T3ch.2024**'
    },
    klaviyo: {
      publicApiKey: 'Ufqp3c'
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=phillyfoodworks-testing.com'
    },
    authorize: {
      APILoginID: '859vpT8YqF',
      PublicClientkey: '2789LLpawLnj4TJe2s5k7akamxnXS3aTq442sEs4vkU82JnTQ56e93fNuMUXmfC6'
    }
  },
  application: {
    angular: 'Angular 17.3.7',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Philly Foodworks',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-pfw',
    crypto: {
      key: '',
    },
    flows: {
      territories: false,
      membership: true,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: false
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order',
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: true,
        showFreeDeliverySlider: false,
        voluntaryDonationFlow: true,
      },
      bundles: {
        modifyType: BundleModifyTypes.default
      },
      shop: {
        validateMarketState: true,
        displayCategoryName: true
      },
      login: {
        tempResetPassword: false
      },
      purchase: {
        type: PurchaseTypes.anet
      }
    },
    filesVersionNumber: {
      logo: 1
    },
    friendReferral: {
      baseUrl: '3.19.44.52:8081/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Local Organic Produce and Food Delivery in Philadelphia | Philly Foodworks',
      mainDescription: 'Discover Philly Foodworks: Local organic produce and food delivery in Philadelphia. Fresh, sustainable, and community-focused.',
      baseTitle: 'Philly Foodworks Local Organic Produce and Food Delivery',
      baseKeywords: ['local', 'organic', 'produce', 'food delivery', 'Philadelphia', 'Philly Foodworks'],
      type: 'website',
      baseURL: 'https://phillyfoodworks.com/'
    },
    contactEmail: 'info@phillyfoodworks.com'
  },
};
